import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { vendorsAPI } from '../../services/api';
import toast from 'react-hot-toast';
import '../../styles/data-form.css';
import { getDisplayCurrency } from '../../utils/currency';

export default function VendorForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: '', display_name: '', email: '', phone: '', mobile: '', website: '',
    company_name: '', first_name: '', last_name: '',
    payment_terms: 'Net30', currency: getDisplayCurrency(),
    address_line1: '', address_line2: '', city: '', state: '', postal_code: '', country: 'US',
    tax_id: '', notes: '',
  });
  const [loading, setLoading] = useState(false);
  useEffect(() => { if (id) vendorsAPI.get(id).then(d => setForm(prev => ({ ...prev, ...d }))).catch(e => toast.error(e.message)); }, [id]);
  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      if (id) { await vendorsAPI.update(id, form); toast.success('Vendor updated'); }
      else { await vendorsAPI.create(form); toast.success('Vendor created'); }
      navigate('/vendors');
    } catch (err) { toast.error(err.message); }
    setLoading(false);
  };
  const u = (f) => (e) => setForm({ ...form, [f]: e.target.value });
  return (
    <div className="df-editor">
      <div className="df-section-header"><span>{id ? 'Edit Vendor' : 'New Vendor'}</span></div>
      <form onSubmit={handleSubmit}>
        <div className="df-body">
          <div className="df-section-title">Contact Information</div>
          <div className="df-grid">
            <div className="df-field"><label>Vendor Name <span className="req">*</span></label><input required value={form.name || ''} onChange={u('name')} /></div>
            <div className="df-field"><label>Display Name</label><input value={form.display_name || ''} onChange={u('display_name')} /></div>
            <div className="df-field"><label>Company</label><input value={form.company_name || ''} onChange={u('company_name')} /></div>
            <div className="df-field"><label>First Name</label><input value={form.first_name || ''} onChange={u('first_name')} /></div>
            <div className="df-field"><label>Last Name</label><input value={form.last_name || ''} onChange={u('last_name')} /></div>
            <div className="df-field"><label>Email</label><input type="email" value={form.email || ''} onChange={u('email')} /></div>
            <div className="df-field"><label>Phone</label><input value={form.phone || ''} onChange={u('phone')} /></div>
            <div className="df-field"><label>Mobile</label><input value={form.mobile || ''} onChange={u('mobile')} /></div>
            <div className="df-field"><label>Website</label><input value={form.website || ''} onChange={u('website')} /></div>
          </div>
          <div className="df-divider" />
          <div className="df-section-title">Address</div>
          <div className="df-grid">
            <div className="df-field full"><label>Address Line 1</label><input value={form.address_line1 || ''} onChange={u('address_line1')} /></div>
            <div className="df-field full"><label>Address Line 2</label><input value={form.address_line2 || ''} onChange={u('address_line2')} /></div>
            <div className="df-field"><label>City</label><input value={form.city || ''} onChange={u('city')} /></div>
            <div className="df-field"><label>State</label><input value={form.state || ''} onChange={u('state')} /></div>
            <div className="df-field"><label>Postal Code</label><input value={form.postal_code || ''} onChange={u('postal_code')} /></div>
            <div className="df-field"><label>Country</label><input value={form.country || ''} onChange={u('country')} /></div>
          </div>
          <div className="df-divider" />
          <div className="df-section-title">Payment Details</div>
          <div className="df-grid">
            <div className="df-field">
              <label>Payment Terms</label>
              <select value={form.payment_terms || 'Net30'} onChange={u('payment_terms')}>
                <option value="DueOnReceipt">Due on Receipt</option><option value="Net15">Net 15</option>
                <option value="Net30">Net 30</option><option value="Net60">Net 60</option>
              </select>
            </div>
            <div className="df-field">
              <label>Currency</label>
              <select value={form.currency || 'USD'} onChange={u('currency')}>
                <option value="USD">USD</option><option value="EUR">EUR</option><option value="GBP">GBP</option><option value="CAD">CAD</option>
              </select>
            </div>
            <div className="df-field"><label>Tax ID</label><input value={form.tax_id || ''} onChange={u('tax_id')} /></div>
          </div>
          <div className="df-divider" />
          <div className="df-section-title">Notes</div>
          <div className="df-grid"><div className="df-field full"><textarea rows={3} value={form.notes || ''} onChange={u('notes')} placeholder="Internal notes..." /></div></div>
        </div>
        <div className="df-actions">
          <button type="button" className="inv-btn inv-btn-secondary" onClick={() => navigate('/vendors')}>Cancel</button>
          <button type="submit" className="inv-btn inv-btn-primary" disabled={loading}>{loading ? 'Saving...' : id ? 'Update' : 'Create'} Vendor</button>
        </div>
      </form>
    </div>
  );
}
